import { useEffect } from 'react';

export function useSurfsideAnalytics() {
  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR guard

    // If script already loaded, skip
    if (window.surf) return;
    (function (s, u, r, f, i, n, g) {
      if (!s[i]) {
        s.surfContext = s.surfContext || [];
        s.surfContext.push(i);
        s[i] = function () {
          // eslint-disable-next-line prefer-rest-params
          (s[i].q = s[i].q || []).push(arguments);
        };
        s[i].q = s[i].q || [];
        n = u.createElement(r);
        // eslint-disable-next-line unicorn/prefer-query-selector
        g = u.getElementsByTagName(r)[0];
        n.async = 1;
        n.src = f;
        g.parentNode.insertBefore(n, g);
      }
    })(
      window,
      document,
      'script',
      '//cdn.surfside.io/sdk/1.0.0/edge.js',
      'surf'
    );

    const waitForSurf = () => {
      // Initialization
      window.surf('newTracker', 'lume', '//col.surfside.io', {
        appId: 'lume',
        cookieName: 'surf',
        discoverRootDomain: true,
        cookieSameSite: 'Lax',
      });
      window.surf('source:lume', {
        accountId: 'efaa6',
        sourceId: '19f2e',
      });
      window.surf('enableActivityTracking:lume', {
        minimumVisitLength: 30,
        heartbeatDelay: 10,
      });
      window.surf('enableLinkClickTracking:lume');
    };

    waitForSurf();
  }, []);
}
